import { ReactNode } from 'react';
import { DetailsHeaderSkeleton, DetailsLayout } from '@/components/details';
import {
  BookingStateCardSkeleton,
  RecentChangesCardSkeleton,
  RelatedPeopleCardSkeleton,
} from '@/features/dashboard/bookingChanges/components/sidebar';
import { BookingBillViewSkeleton } from '@/features/dashboard/bookingChanges/components/bill';

interface DetailsSkeletonProps {
  /** Liczba zakładek nagłówka — dwie na ekranach osób, pięć na ekranie rezerwacji. */
  tabCount?: number;
  /** Szkielet kolumny treści; domyślnie widok rezerwacji. */
  children?: ReactNode;
}

/**
 * Szkielet całego ekranu operatora — nagłówek, kolumna treści i panel boczny
 * w trybie podglądu. Używany jako `pendingComponent` trasy, zanim rachunek
 * rezerwacji dojedzie z serwera.
 */
const DetailsSkeleton = ({ tabCount = 2, children }: DetailsSkeletonProps) => (
  <DetailsLayout
    header={<DetailsHeaderSkeleton tabCount={tabCount} withBanner />}
    sidebar={
      <div className="flex flex-col gap-3.5">
        <BookingStateCardSkeleton />
        <RelatedPeopleCardSkeleton />
        <RecentChangesCardSkeleton />
      </div>
    }
  >
    {children ?? <BookingBillViewSkeleton />}
  </DetailsLayout>
);

export default DetailsSkeleton;
